module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"optionsActiveCampaignsLabel":"Wyświetlane w pluginie","optionsOtherCampaignsLabel":"Pozostałe sklepy"}}')
  delete Component.options._Ctor
}
